/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Still_Need_HelpInputs */

const en_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still need help?`)
};

const de_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauchen Sie noch Hilfe?`)
};

const fr_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besoin d'aide supplémentaire ?`)
};

const es_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Aún necesita ayuda?`)
};

const it_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai ancora bisogno di aiuto?`)
};

const nl_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heeft u nog hulp nodig?`)
};

const pl_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadal potrzebujesz pomocy?`)
};

const fi_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarvitsetko vielä apua?`)
};

const da_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du stadig brug for hjælp?`)
};

const sv_help_still_need_help = /** @type {(inputs: Help_Still_Need_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behöver du fortfarande hjälp?`)
};

/**
* | output |
* | --- |
* | "Still need help?" |
*
* @param {Help_Still_Need_HelpInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_still_need_help = /** @type {((inputs?: Help_Still_Need_HelpInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Still_Need_HelpInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_still_need_help(inputs)
	if (locale === "fr") return fr_help_still_need_help(inputs)
	if (locale === "es") return es_help_still_need_help(inputs)
	if (locale === "it") return it_help_still_need_help(inputs)
	if (locale === "nl") return nl_help_still_need_help(inputs)
	if (locale === "pl") return pl_help_still_need_help(inputs)
	if (locale === "fi") return fi_help_still_need_help(inputs)
	if (locale === "da") return da_help_still_need_help(inputs)
	if (locale === "sv") return sv_help_still_need_help(inputs)
	return en_help_still_need_help(inputs)
});